import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    ExternalConsignmentLinkColumn,
    MultilineExternalReceptacleLinkColumn,
    MultilineColumn,
    MultilineDateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'consignmentId')),
      ],
    },
    {
      Header: 'Origin',
      columns: [
        new TextColumn('Country', 'origin.country'),
        new TextColumn('Location', 'origin.location'),
      ],
    },
    {
      Header: 'Destination',
      columns: [
        new TextColumn('Country', 'destination.country'),
        new TextColumn('Location', 'destination.location'),
      ],
    },
    {
      Header: '',
      columns: [
        new DateTimeColumn('Completion date', 'destination.completionDate'),
        new DateTimeColumn('Planned arrival', 'destination.plannedArrivalDate'),
        new NonZeroNumberColumn('PRECON', 'destination.precon'),
        new NonZeroNumberColumn('RESCON', 'destination.rescon'),
        new MultilineExternalReceptacleLinkColumn('Receptacle ID', 'destination.receptacleId').withWidth(300),
        new MultilineColumn('Mail category', 'destination.mailCategory'),
        new MultilineColumn('Mail subclass', 'destination.mailSubclass'),
      ],
    },
    {
      Header: 'RESCON',
      columns: [
        new MultilineDateTimeColumn('Event date', 'rescon.eventDate'),
      ],
    },
  ];
};
